<template>
  <div id="product">
    <div
      class="productNav"
      v-show="isShow"
      :class="navBarFixed == true ? 'navBarWrap' : ''"
    >
      <div
        class="navItem"
        :class="{ activeBtn: activeNav == index ? true : false }"
        v-for="(item, index) in itemNavArr"
        :key="index"
        @click="clickNavItem(item.ref, index)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="productPanel">
      <h2 class="panelTitle">我们的产品</h2>
      <div class="panelNameRow">
        <div
          v-for="(item, index) in itemNavArr"
          :key="index"
          :class="{ activePanel: activePanel == index ? true : false }"
          @click="clickPanelItem(item.ref, index)"
          class="panelItem"
        >
          <img
            :src="activePanel == index ? item.iconActive : item.icon"
            alt=""
          />
          <div class="panelName">{{ item.name }}</div>
        </div>
      </div>
    </div>

    <Fire ref="fire" id="fire" />
    <Electric ref="electric" id="electric" />
    <Perception ref="perception" id="perception" />
    <Inspection ref="inspection" id="inspection" />
    <Rtc ref="rtc" id="rtc" />
    <Video ref="video" id="video" />
  </div>
</template>

<script>
import Fire from "./components/fire";
import Electric from "./components/electric";
import Perception from "./components/perception";
import Inspection from "./components/inspection";
import Rtc from "./components/rtc";
import Video from "./components/video";
export default {
  props: {},
  data() {
    return {
      navBarFixed: false,
      itemNavArr: [
        {
          name: "智慧消防",
          value: 0,
          icon: require("../../assets/img/home/xiaofang.svg"),
          iconActive: require("../../assets/img/home/xiaofang2.svg"),
          ref: "fire",
        },
        {
          name: "智慧用电",
          value: 1,
          icon: require("../../assets/img/home/yongdian.svg"),
          iconActive: require("../../assets/img/home/yongdian2.svg"),
          ref: "electric",
        },
        {
          name: "独立感知",
          value: 2,
          icon: require("../../assets/img/home/ganzhi.svg"),
          iconActive: require("../../assets/img/home/ganzhi2.svg"),
          ref: "perception",
        },
        {
          name: "智慧巡检",
          value: 3,
          icon: require("../../assets/img/home/xunjian.svg"),
          iconActive: require("../../assets/img/home/xunjian2.svg"),
          ref: "inspection",
        },
        {
          name: "视频RTC",
          value: 4,
          icon: require("../../assets/img/home/rtc.svg"),
          iconActive: require("../../assets/img/home/rtc2.svg"),
          ref: "rtc",
        },
        {
          name: "视频识别",
          value: 5,
          icon: require("../../assets/img/home/shibie.svg"),
          iconActive: require("../../assets/img/home/shibie2.svg"),
          ref: "video",
        },
      ],
      activeNav: -1,
      activePanel: -1,
      isShow: false,
      receiveCate: "",
    };
  },
  computed: {},
  created() {},
  mounted() {
    window.addEventListener("scroll", this.watchScroll);
    let cateId = this.$route.params.category;
    if (cateId == undefined) {
      return false;
    }

    if (cateId == 1) {
      this.receiveCate = "fire";
    } else if (cateId == 2) {
      this.receiveCate = "electric";
    } else if (cateId == 3) {
      this.receiveCate = "perception";
    } else if (cateId == 4) {
      this.receiveCate = "inspection";
    } else if (cateId == 5) {
        this.receiveCate = "rtc";
        } else if (cateId == 6) {
        this.receiveCate = "video";
    }
    this.clickNavItem(this.receiveCate, cateId - 1);
  },
  watch: {},
  methods: {
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //  当滚动超过 200 时，实现吸顶效果
      if (scrollTop > 400) {
        this.isShow = true;
        this.navBarFixed = true;
      } else {
        this.isShow = false;
        this.navBarFixed = false;
      }
    },
    clickNavItem(refName, index) {
      this.activeNav = index;
      this.activePanel = index;
      let height = this.$el.querySelector("#" + refName).offsetTop - 250;
      window.scroll({ top: height, left: 0, behavior: "smooth" });
    },
    clickPanelItem(refName, index) {
      this.activePanel = index;
      this.activeNav = index;
      let height = this.$el.querySelector("#" + refName).offsetTop - 250;
      window.scroll({ top: height, left: 0, behavior: "smooth" });
    },
  },
  components: {
    Fire,
    Electric,
    Perception,
    Inspection,
    Rtc,
    Video,
  },
};
</script>

<style scoped lang="scss">
#product {
  .productNav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 5rem;
    box-shadow: 0px 2px 3px -1px rgba(172, 172, 172, 0.17);
    background: #ffffff;
    padding: 1.5rem 14%;
    .navItem {
      font-size: 1.6rem;
      font-weight: bold;
      color: #333333;
      line-height: 4.2rem;
      cursor: pointer;
      width: 15%;
      text-align: center;
    }
    .activeBtn {
      background: #13baa1;
      border-radius: 2rem;
      color: #fff;
    }
  }
  .productPanel {
    padding: 5% 14%;
    background: linear-gradient(
      -42deg,
      rgba(91, 175, 253, 0.06),
      rgba(192, 248, 230, 0.06)
    );
    .panelTitle {
      font-size: 2.6rem;
      color: #333333;
      line-height: 4rem;
      text-align: center;
      margin-bottom: 5rem;
    }
    .panelNameRow {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .panelItem {
        width: 15%;
        height: 20rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:hover {
          box-shadow: 0px 1rem 2rem 0px rgba(48, 55, 66, 0.15);
          transform: translate(0, -5px);
          transition: all 0.3s;
        }
        img {
          width: 6rem;
          height: 6rem;
        }
        .panelName {
          font-size: 1.6rem;
          color: #333333;
          font-weight: bold;
          line-height: 4rem;
        }
      }
      .activePanel {
        background: #ffffff;
        box-shadow: 0px 7px 16px 0px rgba(146, 146, 146, 0.09);
        border-radius: 1rem 1rem 0 0;
        border-bottom: 2px solid #00b7a4;
        img {
          background: linear-gradient(125deg, #00b7a4, #0dca81);
          border-radius: 50%;
        }
      }
    }
  }
  .navBarWrap {
    position: fixed;
    top: 9rem;
    width: 100%;
    z-index: 999;
  }
}
@import '../../assets/responsive/product.scss';
</style>
